import { faDownload } from "@fortawesome/free-solid-svg-icons";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import React from "react";
import ReactTable from "react-table";
import { Col, Container, Row } from "reactstrap";
import BaseButtonWithIconAndTooltip from "../../../toolkit/baseButtonWithIconAndTooltip";
import constants from "../../../utils/constants";
import {
  errorNotification,
  infoNotification,
  successNotification
} from "../../../utils/notifications";
import { downloadReportConciliacionFinanzasFileId } from "../../actions/reports";
import { PropsConciliacionFinanzas } from "./interfaces";
import s from "./styles.scss";

class TableReportConciliacionFinanzas extends React.Component<
  PropsConciliacionFinanzas
> {
  state = {
    downloading: false
  };
  //COLUMN DEFINITION
  columns = [
    {
      Header: () => <p className="font-weight-bold">DESCRIPCION</p>,
      width: 300,
      accessor: "descripcion"
    },
    {
      Header: () => <p className="font-weight-bold">VALOR</p>,
      width: 150,
      className: "text-center",
      accessor: "valor"
    },
    {
      Header: "",
      width: "320",
      maxWidth: "320",
      Cell: row => {
        const { tipo } = row.original;
        return (
          <div>
            {" "}
            <BaseButtonWithIconAndTooltip
              id={`isdownloadReport_${tipo}`}
              icon={faDownload}
              tooltipTitle={"Descargar reporte"}
              onClick={() => {
                this.downloadReport(tipo, this.props.fecha);
              }}
            />
          </div>
        );
      }
    }
  ];

  //CONTROL BEHAVIOR
  downloadReport = (tipo, fecha) => {
    if (!!this.state.downloading) {
      return;
    }

    infoNotification("Descargando reporte...");

    this.setState({ downloading: true });

    downloadReportConciliacionFinanzasFileId({ tipo, fecha })
      .then(({ data }) => {
        successNotification("Reporte descargado correctamente");
        this.setState({ downloading: false });
        const url = `${constants.BASE_URL}/${constants.DOCUMENTS_BASE_URL}/${data}`;
        window.open(url, "_blank");
      })
      .catch(err => {
        this.setState({ downloading: false });
        const msg = "No se pudo descargar el archivo";
        if (err && err.response && err.response.data) {
          try {
            const message = JSON.parse(err.response.data).message || msg;
            errorNotification(message);
          } catch (erj) {
            errorNotification(msg);
          }
        } else {
          errorNotification(msg);
        }
      });
  };

  //RENDER
  render() {
    return (
      <Container className="p-0">
        {!!(this.props.data || []).length && (
          <Row className={"mt-5"}>
            <Col sm="6">
              Resultados de la búsqueda:{" "}
              <b
                style={{ fontWeight: "bolder", display: "inline-block" }}
                className="ml-3"
              >
                {(this.props.data || []).length}
              </b>
            </Col>
            <Col sm="6" className="text-right"></Col>
          </Row>
        )}

        <ReactTable
          data={this.props.data}
          columns={this.columns}
          className="mt-2 -striped -highlight"
          sortable={false}
          resizable={true}
          pageSize={20}
          loading={this.props.onSearch}
        />
      </Container>
    );
  }
}

export default withStyles(s)(TableReportConciliacionFinanzas);
